module.exports = __webpack_public_path__ + "static/img/qnstatus2.c32dee8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qnstatus2.png
// module id = 364
// module chunks = 0